import React from "react";
import RegisterForm from "../components/forms/RegisterForm";
import logo from "../assets/logo2.png";
import bggImg from "../assets/bgg.jpg";

export default function Register() {
  return (
    <div className="min-h-screen bg-[#f5f5f0] flex flex-col lg:flex-row">
      {/* Left panel */}
      <div className="hidden lg:flex lg:w-[45%] relative bg-[#0d3d2e] flex-col justify-between p-12 overflow-hidden shrink-0">
        <div className="absolute inset-0">
          <img src={bggImg} alt="" className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-[#0d3d2e]/80" />
        </div>
        <div className="relative z-10">
          <a href="/" className="flex items-center gap-3 mb-16 hover:opacity-90 transition">
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-lg overflow-hidden">
              <img src={logo} alt="UCH" className="w-8 h-8 object-contain" />
            </div>
            <div>
              <p className="text-white font-bold text-base leading-tight">UCH Self Service</p>
              <p className="text-green-300 text-xs">University College Hospital, Ibadan</p>
            </div>
          </a>

          <h1 className="text-4xl font-bold text-white leading-tight mb-6">
            Start your<br />
            <span className="text-green-400">digital health</span><br />
            journey today.
          </h1>
          <p className="text-green-200 text-sm leading-relaxed max-w-sm mb-10">
            Create your UCH wallet in minutes. Fund it once and pay for any hospital service instantly.
          </p>

          <div className="space-y-4">
            {[
              "Free to create — no hidden fees",
              "Secure digital receipts for all payments",
              "Pay for any UCH service from anywhere",
              "24/7 support available",
            ].map((f) => (
              <div key={f} className="flex items-center gap-3">
                <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center shrink-0">
                  <span className="text-white text-[10px] font-bold">✓</span>
                </div>
                <p className="text-green-200 text-sm">{f}</p>
              </div>
            ))}
          </div>
        </div>
        <p className="relative z-10 text-green-400 text-xs">
          © {new Date().getFullYear()} University College Hospital, Ibadan.
        </p>
      </div>

      {/* Right panel */}
      <div className="flex-1 flex flex-col min-h-screen lg:min-h-0">
        {/* Mobile top bar */}
        <div className="lg:hidden bg-[#0d3d2e] px-5 py-4 flex items-center gap-3">
          <a href="/" className="flex items-center gap-2.5">
            <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center overflow-hidden">
              <img src={logo} alt="UCH" className="w-7 h-7 object-contain" />
            </div>
            <div>
              <p className="text-white font-bold text-sm leading-tight">UCH Self Service</p>
              <p className="text-green-300 text-xs">University College Hospital</p>
            </div>
          </a>
        </div>

        <div className="flex-1 flex items-start justify-center bg-[#f5f5f0] px-4 py-8 sm:px-6 sm:py-10 overflow-y-auto">
          <div className="w-full max-w-[440px]">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8">
              <div className="mb-6">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">Create your account</h2>
                <p className="text-gray-500 text-sm">Set up your UCH wallet — takes less than 2 minutes.</p>
              </div>
              <RegisterForm />
            </div>
            <p className="text-center text-xs text-gray-400 mt-5">
              Already have an account?{" "}
              <a href="/login" className="text-[#0d3d2e] font-semibold hover:underline">Sign in</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
